import React from "react";
import pdfLogo from "../../../../assets/images/pdfLogo.png";
import { Box, Typography } from "@material-ui/core";
import backgroundGradient from "../../../../assets/images/gradientBackground.png";
import { useLocation } from "react-router";
export const LastPage = ({ type }) => {
  const container = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "11.3in",
    backgroundColor: "#ffffff",
    width: "100%",
    backgroundImage: type == "pdf" ? `url(${backgroundGradient})` : "none",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };
  function getTextColor() {
    let black = "#000000";
    let white = "#FFFFFF";
    return type == "print" ? black : white;
  }
  return (
    <div className="pdf-page" style={container}>
      <Box className="logo">
        <img src={pdfLogo} style={{ width: "70px", height: "90px" }} />
        {/* <p
          style={{
            marginTop: "2px",
            fontWeight: "500",
            textAlign: "center",
            color: getTextColor(),
          }}
        >
          Do Good
        </p> */}
      </Box>
    </div>
  );
};
